import { render, staticRenderFns } from "./AggiungiPrenotazione.vue?vue&type=template&id=9675dd78&scoped=true&"
import script from "./AggiungiPrenotazione.vue?vue&type=script&lang=js&"
export * from "./AggiungiPrenotazione.vue?vue&type=script&lang=js&"
import style0 from "./AggiungiPrenotazione.vue?vue&type=style&index=0&id=9675dd78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9675dd78",
  null
  
)

export default component.exports